// export const MESSAGE_SENT = 'MessageSent'
// export const MESSAGE_SENT = 'Chat.Message.MessageSent'
const eventPrefix = 'DNC.Messenger.Laravel.Events.Broadcast'

export const MESSAGE_SENT = 'App.Events.Chat.Message.MessageSent'
export const USER_MUTE = `${eventPrefix}.Participant.ParticipantBlocked`
export const USER_UNMUTE = `${eventPrefix}.Participant.ParticipantUnBlocked`
export const MESSAGE_DELETED = `${eventPrefix}.Message.MessageDeleted`
// export const ERROR = 'error'
